// extracted by mini-css-extract-plugin
export default {"root":"SetDetailModal_root__zNsM-","actionButtons":"SetDetailModal_actionButtons__Njrts","firstContainer":"SetDetailModal_firstContainer__du1qf"};